import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'message-banner',
    templateUrl: './message-banner.template.html',
    styleUrls: ['./message-banner.style.scss'],
    standalone: false
})
export class MessageBanner implements OnInit{
    @Input() msgBannerData: any;

    constructor() { }

    ngOnInit() {
    }
}